<template>
  <el-dialog
      :visible.sync="visible"
      title="发票修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      :append-to-body="true"
  >
    <div class="table-bar" style="margin-bottom: 0">
      <el-form
          :inline="true"
          :model="queryForm"
          @keyup.enter.native="$refs.table.getDataList()"
          ref="queryForm"
          class="query-form"
      >
        <el-form-item prop="orderCode" label="外销合同号：">
          <el-input
              v-model="queryForm.orderCode"
              size="mini"
              clearable
              type="text"
              placeholder="请输入外销合同号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="storeName" label="仓库：">
          <el-input
              v-model="queryForm.storeName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入仓库名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="productCode" label="品番号：" >
          <el-input
              v-model="queryForm.productCode"
              size="mini"
              clearable
              type="text"
              placeholder="请输入品番号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="productName" label="品名：">
          <el-input
              v-model="queryForm.productName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入品名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="productName" label="颜色：">
          <el-input
              v-model="queryForm.color"
              size="mini"
              clearable
              type="text"
              placeholder="请输入颜色"
          ></el-input>
        </el-form-item>
        <el-form-item prop="productName" label="规格：">
          <el-input
              v-model="queryForm.size"
              size="mini"
              clearable
              type="text"
              placeholder="请输入规格"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button  @click="$refs.table.reload()" size="mini">查询</el-button>
          <el-button  @click="submitSel" size="mini" type="primary">确定选择</el-button>
        </el-form-item>
      </el-form>
    </div>
    <SweetTable ref="table" :selection="true" url="/trade/factorystorelog/page" :query-form="queryForm"
                delete-url="/store" :height="500" :after-table-binding="afterTableBinding">
      <el-table-column
          prop="agreementCode"
          label="合同编号"
          min-width="160"
          fixed="left"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="senderName"
          label="供应商"
          :formatter="$c.companyNameFormatter"
          min-width="160"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="storageName"
          label="仓库名称"
          :formatter="$c.companyNameFormatter"
          min-width="160"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column prop="productCode" label="品番号" min-width="90"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="skuCode" label="SKU" min-width="90"  header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="productName" label="品名" min-width="90" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="color" label="颜色" min-width="90" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="size" label="规格" min-width="90" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="attr1" label="幅宽" min-width="90"  header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="attr2" label="克重" min-width="90"  header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="nameZh" label="中文品名" min-width="120" header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="count" label="数量" min-width="90" header-align="center"
                       align="center">
        <template #default="{row}">
          <div style="color:#67C23A;" v-if="row.type === 1">
            {{ row.count }}
          </div>
          <div style="color:#F56C6C;" v-else-if="row.type === -1">
            {{ row.count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="operateTime" label="出入库日期" width="100" header-align="center"
                       align="center"></el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
export default {
  name: 'PayDetailSelDialog',
  data(){
    return {
      visible:false,
      queryForm: {
        productCode: undefined,
        productType: '',
        productName: '',
        orderCode: '',
        storeName: '',
        storeType: '1',
        senderName: '',
        isBack: '',
        hasReceipt: '',
        beginDate: '',
        endDate: '',
        creatorName: '',
        color: '',
        size: '',
        reason: '',
        senderId:''
      },
      ids:[]
    }
  },
  methods:{
    submitSel(){
      this.$emit('change',this.$refs.table.dataListSelections)
      this.visible=false
    },
    init(ids){
      this.ids=ids
      this.visible=true
      this.$nextTick(()=>{
        let tableEl=this.$refs.table.tableEL
        tableEl.clearSelection()
        this.$refs.table.reload()
      })
    },
    afterTableBinding(dataList){
      let tableEl=this.$refs.table.tableEL
      if(this.ids&&this.ids.length>0){
        this.ids.forEach(id=>{
          let row=dataList.find(d=>d.id==id)
          if(!row){
            return
          }
          tableEl.toggleRowSelection(row,true)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
